const isRepaymentAmount = (title: string) => title.includes('repayment_amount')

export default isRepaymentAmount
